import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const HomepageNetTermsMoreProminentPage = lazy(
  () => import("../../pages/HomepageNetTermsMoreProminentPage")
);

export function TaraRaoPanditRoutes() {
  return (
    <Switch>
      <Route
        path="/trp/homepage-net-terms-more-prominent"
        component={HomepageNetTermsMoreProminentPage}
      />
    </Switch>
  );
}

export const slug = "trp";
